import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor() { }

  handleApiError(err) {
    const fromBody = this.extractErrorMessage(err && err.error);
    if (fromBody) {
      return fromBody;
    }

    switch (err && err.status) {
      case 0:
        return 'There is no network connection';
      case 401:
        return 'You entered a wrong username or password';
      case 502:
        return 'The upstream service failed. Please try again.';
      default:
        return (err && err.message) ? err.message : 'Unknown error';
    }
  }

  /** Prefer API body fields used across FR endpoints (camelCase + PascalCase). */
  private extractErrorMessage(body: any): string {
    if (body == null) {
      return '';
    }
    if (typeof body === 'string') {
      const trimmed = body.trim();
      if (!trimmed) {
        return '';
      }
      // Some proxies return HTML for 502; keep the alert readable.
      if (trimmed.charAt(0) === '<' || trimmed.toLowerCase().indexOf('<!doctype') === 0) {
        return '';
      }
      try {
        const parsed = JSON.parse(trimmed);
        return this.extractErrorMessage(parsed);
      } catch {
        return trimmed;
      }
    }
    if (typeof body !== 'object') {
      return '';
    }

    const candidates = [
      body.message,
      body.Message,
      body.detail,
      body.Detail,
      body.title,
      body.Title,
      body.error_description,
      body.error
    ];

    for (let i = 0; i < candidates.length; i++) {
      const value = candidates[i];
      if (typeof value === 'string' && value.trim()) {
        return value.trim();
      }
    }

    return '';
  }
}
